import { call } from 'redux-saga/effects';
import { getFirebase } from 'react-redux-firebase';

import { COLLECTION } from '../../../../constants/collection';
import {
  FIELDS,
  POSTER_FIELDS,
  POSTER_PATH
} from '../../../../constants/eventForm';
import { getActiveEvent } from '../../selectors';
import store from '../../../store/store';

const deletePoster = function* deletePoster(uid, key, id) {
  yield store.firebase.deleteFile(
    `${COLLECTION.POSTERS}/${uid}/${key}`,
    `${COLLECTION.POSTERS}/${id}`,
  );
};

const getPosterKey = filename => {
  const timestamp = new Date().getTime();
  const fileExtension = filename.split('.').pop();
  const id = `${filename.split('.')[0]}-${timestamp}`;
  return `${id}.${fileExtension}`;
};

const updateActiveEventPosterIfChanged = function* updateActiveEventPosterIfChanged(values, uid) {
  const activeEvent = yield call(getActiveEvent);
  const initialId = activeEvent[FIELDS.POSTER][POSTER_FIELDS.ID];
  const initialKey = activeEvent[FIELDS.POSTER][POSTER_FIELDS.KEY];

  if (initialId !== values[FIELDS.POSTER][POSTER_FIELDS.ID]) {
    values = yield call(uploadFile, values, uid);
    yield call(deletePoster, uid, initialKey, initialId);
  }

  return values;
};

const uploadFile = function* uploadFile(values, uid) {
  const file = values[FIELDS.POSTER][POSTER_FIELDS.FILE];
  const key = getPosterKey(values[FIELDS.POSTER][POSTER_FIELDS.NAME]);

  const poster = yield getFirebase().uploadFile(
    `${POSTER_PATH}/${uid}`,
    file,
    POSTER_PATH,
    { name: key },
  );
  values[FIELDS.POSTER][POSTER_FIELDS.ID] = poster.id;
  values[FIELDS.POSTER][POSTER_FIELDS.KEY] = key;
  // Intentionally duplicated these FileMetadata fields
  values[FIELDS.POSTER][POSTER_FIELDS.URL] = poster.downloadURL;
  delete values[FIELDS.POSTER][POSTER_FIELDS.FILE];
  return values;
};

export {
  deletePoster,
  getPosterKey,
  updateActiveEventPosterIfChanged,
  uploadFile,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/events/utils/file.js